import React from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Button, Card, CardBody, CardFooter, CardText, Col, Row } from 'reactstrap';

function SingleReportUserCard({ data }) {
    return (

        <Col md="4">
            <Card className="card-user shadow-lg">
                <CardBody className='pb-0'>
                    <CardText />
                    <Row className='mx-3 mb-2' >
                        <div>
                            <p>Report Type :</p>
                        </div>
                        <div className=' ml-3 px-4 py-1 bg-warning  rounded text-white'>
                            <p className='text-white'>
                                {data.reportType}
                            </p>

                        </div>
                    </Row>
                    <Row className='mx-2'>
                        <Card className="card-user shadow-lg">


                            <div className="Single_author">
                                <div className="block block-one" />
                                <div className="block block-two" />
                                <div className="block block-three" />
                                <div className="block block-four" />
                                <div className="d-flex justify-content-between  " >
                                    <div className=" d-flex ">
                                        <img
                                            alt="..."
                                            className="avatar_single_user"
                                            src={data?.reportUserProfilePic}
                                        />

                                        <div className="ml-2 mt-2">
                                            <div className='d-flex'>
                                                <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{data?.reportByName}</p>
                                            </div>

                                        </div>

                                    </div>
                                    <p className="description text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                                </div>



                            </div>




                        </Card>
                    </Row>
                    <div className='d-flex justify-content-center  '>
                        <p className='bg-danger px-3 py-2 rounded'>Reported</p>
                    </div>
                    <Row className='mx-2'>
                        <Card className="card-user shadow-lg">

                            <div className="Single_author">
                                <div className="block block-one" />
                                <div className="block block-two" />
                                <div className="block block-three" />
                                <div className="block block-four" />
                                <div className="d-flex justify-content-between  " >
                                    <div className=" d-flex ">
                                        <img
                                            alt="..."
                                            className="avatar_single_user"
                                            src={data?.userReportedProfilePic}
                                        />

                                        <div className="ml-2 mt-2">
                                            <div className='d-flex'>
                                                <p className="description font-weight-bolder" style={{ fontSize: '14px' }}>@{data?.userReportedName}</p>
                                            </div>

                                        </div>

                                    </div>
                                    <p className="description  text-white m-2" style={{ fontSize: '14px' }}>Beyown user</p>


                                </div>



                            </div>



                        </Card>
                    </Row>

                    <Row className='d-flex justify-content-center '>
                        <Link className="text-white d-flex justify-content-center btn" to={`/admin/Reported-Users/SingleCase/${data?.uniqueId}`}>

                            See Full Case

                        </Link>
                    </Row>

                </CardBody>
                <CardFooter className='pt-0'>

                </CardFooter>
            </Card>
        </Col>

    )
}

export default SingleReportUserCard